import {
  EventStore,
  EventModel,
  AssignmentStore,
  ResourceStore,
  ResourceModel,
  TimeRangeStore,
} from "@bryntum/schedulerpro";

import C from "../../Constants";

// == Model定義 ===
class VesselEventModel extends EventModel {
  static get fields() {
    return [
      { name: "name", readOnly: true, defaultValue: "", persist: false },
      { name: "startDate", dataSource: "start_date" },
      { name: "endDate", dataSource: "end_date" },
      // カスタムフィールド
      { name: "crew_id", persist: true, readOnly: true },
      { name: "scheduling_status" },
      { name: "alerts", defaultValue: [], persist: false },
      { name: "enterprise_manning_vessel_crew_id" },
      { name: "phantom_group_key", persist: true, defaultValue: null },
      // 楽観ロック用のバージョン番号
      { name: "version", persist: true, defaultValue: null },
      // イベント種類（乗船）
      {
        name: "event_type",
        persist: false,
        defaultValue: C.SCHEDULING_EVENT_TYPE.VESSEL,
      },
      // 内部用削除フラグ
      { name: "innerDelete", persist: false, defaultValue: false },
      // 内部用用リプレースフラグ レコードをコピー&削除するフラグ
      { name: "innerReplace", persist: false, defaultValue: false },
      // 不要なデータは送らない
      // durationの単位は分にする。
      { name: "duration", persist: false },
      { name: "durationUnit", persist: false, defaultValue: "minute" },
      { name: "cls", persist: false },
      { name: "calendar", persist: false },
      { name: "direction", persist: false },
      { name: "manuallyScheduled", persist: false, defaultValue: true },
      { name: "unscheduled", persist: false },
      { name: "ignoreResourceCalendar", persist: false },
      { name: "percentDone", persist: false },
      { name: "effort", persist: false },
      { name: "effortUnit", persist: false },
      { name: "segments", persist: false },
      { name: "effortDriven", persist: false },
      { name: "schedulingMode", persist: false },
      { name: "constraintType", persist: false, defaultValue: null },
      { name: "constraintDate", persist: false, defaultValue: null },
      { name: "inactive", persist: false },
      { name: "delayFromParent", persist: false },
      { name: "exceptionDates", persist: false },
      { name: "allDay", persist: false },
      { name: "eventColor", persist: false },
      { name: "showInTimeline", persist: false },
      { name: "preamble", persist: false },
      { name: "postamble", persist: false },
    ];
  }
}

class Resouce extends ResourceModel {
  static fields = [
    { name: "name", readOnly: true },
    { name: "required", readOnly: true },
    { name: "visible", persist: false, defaultValue: true },
  ];
  get readOnly() {
    return this.isParent;
  }

  get rowHeight() {
    if (this.isLeaf) {
      return super.rowHeight;
    }
    return 45;
  }
}

// == Store定義 ===

const VesselEventStore = new EventStore({
  sorters: [{ field: "startDate", ascending: true }],
  modelClass: VesselEventModel,
  onLoad(event) {
    const store = event.source;
    // 予定レコードはドラッグ禁止
    store.forEach(record => {
      if (record.scheduling_status === C.SCHEDULING_STATUS.SCHEDULED) {
        record.set("draggable", false);
      }
    });
  },
});

const VesselAssignmentStore = new AssignmentStore({
  fields: [
    { name: "eventId", dataSource: "event_id" },
    { name: "resourceId", dataSource: "resource_id" },
    { name: "units", persist: false, defaultValue: 100 },
  ],
});

const VesselResourceStore = new ResourceStore({
  tree: true,
  modelClass: Resouce,
});

const VesselTimeRangeStore = new TimeRangeStore({});

export {
  VesselEventModel,
  VesselEventStore,
  VesselResourceStore,
  VesselTimeRangeStore,
  VesselAssignmentStore,
};
